import styled from "@emotion/styled";

export const StyledContextItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  padding: ${({ theme }) => `${theme.spacing["1"]} ${theme.spacing["1"]} 0 ${theme.spacing["1"]}`};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};

  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  user-select: none;
`;

export const StyledContextIcon = styled.span`
  display: flex;
  align-items: center;
`;

export const StyledContextText = styled.span`
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.smedium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;
